/* eslint-disable max-len */
import API from 'utils/api';
import { onError } from 'utils/handlers';

export const baseURI = 'catalogos/dato-de-pago-del-honorario-asimilado';

export const getDatosDePagoDeHonorariosAsimilados = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

export const getDatoDePagoDelHonorarioAsimilado = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

export const postDatoDePagoDelHonorarioAsimilado = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

export const patchDatoDePagoDelHonorarioAsimilado = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

export const deleteDatoDePagoDelHonorarioAsimilado = async (id) => {
  try {
    await API.delete(`${baseURI}/${id}`);
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

export const putDatoDePagoDelHonorarioAsimilado = async (values) => {
  try {
    const response = await API.put(baseURI, values);
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};
